import { defineComponent as _defineComponent } from 'vue';
import { BButton, BCol, BFormGroup, BFormInput, BRow } from "bootstrap-vue";
import { computed, ref } from "vue";
import localize from "@/utils/localization";
import FilesInput from "@/components/FilesDialog/FilesInput.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'ExportForm',
    props: {
        what: { default: "archive" },
        clearInputAfterExport: { type: Boolean, default: false }
    },
    emits: ["export"],
    setup(__props, { emit }) {
        const props = __props;
        const defaultExportFilterOptions = { exclude: ["rdm"] };
        const directory = ref("");
        const name = ref("");
        const canExport = computed(() => name.value.length > 0 && directory.value.length > 0);
        const directoryDescription = computed(() => localize(`Select a 'remote files' directory to export ${props.what} to.`));
        const nameDescription = computed(() => localize("Give the exported file a name."));
        const namePlaceholder = computed(() => localize("Name"));
        const doExport = () => {
            emit("export", directory.value, name.value);
            if (props.clearInputAfterExport) {
                directory.value = "";
                name.value = "";
            }
        };
        return { __sfc: true, props, emit, defaultExportFilterOptions, directory, name, canExport, directoryDescription, nameDescription, namePlaceholder, doExport, BButton, BCol, BFormGroup, BFormInput, BRow, FilesInput };
    }
});
